import React, { useCallback } from 'react';

import style from './Toggle.module.scss';

export interface ToggleProps {
  checked: boolean;
  name: string;
  onChange: (e: boolean) => void;
  leftLabel: string;
  rightLabel: string;
}

const Toggle = ({
  checked,
  onChange,
  name,
  leftLabel,
  rightLabel,
}: ToggleProps): JSX.Element => {
  const onChangeInput = useCallback(
    ({ target }) => onChange(target.checked),
    [onChange]
  );

  return (
    <label
      data-testid="toggle"
      className={`${style.Toggle} ${style.Toggle__reverse}`}
      htmlFor={name}
      aria-checked={checked}
      aria-label={rightLabel}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
      role="checkbox"
    >
      <input
        type="checkbox"
        id={name}
        onChange={onChangeInput}
        checked={checked}
      />
      <span>{leftLabel}</span>
      <span>{rightLabel}</span>
    </label>
  );
};

export default Toggle;
